/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../../hooks/useForm';
import Modal, { ModalHeader } from '../../Modal';
import Form from '../../Form';
import { isEmpty } from '../../../utils/lodashExtend';
import { toast } from '../../../utils/toast';
import { addTaxpayerScheduleCategory, editTaxpayerScheduleCategory } from '../../../apis/tax-portal/taxpayer';

const defaultForm = {
  name: "",
  color: "#21D4A9",
  isActive: "true",
};

const TaxpayerScheduleCategory = (props) => {
  const { open, setOpen, submit, selectedItem, setSelectedItem, mode } = props;


  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    submit && submit();
    resetForm(defaultForm);
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };

  const [fields] = useState([
    {
      key: "name",
      title: "카테고리명",
      type: "input",
      required: true,
    },
    [
      {
        title: "노출색상",
        key: "color",
        type: "colorpicker",
        required: true,
      },
      {
        title: "사용 여부",
        key: "isActive",
        type: "select",
        required: true,
        options: { list: [{ label: "활성", value: true }, { label: "비활성", value: false }] }
      },
    ]
  ]);

  const _submit = (form) => {
    if (mode === "create") {
      addTaxpayerScheduleCategory(form)
        .then(res => {
          toast.success("등록이 완료되었습니다.");
          cancel();
        }).catch(err => console.error(err.response));
    } else {
      editTaxpayerScheduleCategory(selectedItem.idx, form)
        .then(res => {
          toast.success("수정이 완료되었습니다.");
          cancel();
        }).catch(err => console.error(err.response));

    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setValidateFields,
    setOriginForm,
    resetForm
  } = useForm(
    defaultForm,
    _submit,
  );


  useEffect(() => {
    if (!isEmpty(fields)) setValidateFields(fields);
  }, [fields]);

  useEffect(() => {
    if (selectedItem) {
      setForm({
        ...selectedItem,
        isActive: selectedItem.isActive + ""
      });
      setOriginForm({
        ...selectedItem,
        isActive: selectedItem.isActive + ""
      });
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }

  }, [open, selectedItem]);


  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
      >
        <ModalHeader>
          {`카테고리 ${mode === "create" ? "등록" : "수정"}`}
        </ModalHeader>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === "create" ? "등록" : "수정"}
          submit={handleSubmit}
          cancel={cancel}
        />
      </Modal>
    </>
  );
};

export default TaxpayerScheduleCategory;